function TradingStatus({ status }) {
  const isSuspended = status === "temporary suspended";

  return (
    <span
      className={`inline-block mt-1 px-2 py-[1px] text-[10px] font-medium rounded ${
        isSuspended
          ? "bg-yellow-100 text-yellow-700"
          : "bg-green-100 text-green-700"
      }`}
    >
      {isSuspended ? "⏸ Temporary Suspended" : "● Active"}
    </span>
  );
}

export default TradingStatus;